import ActivityHeader from "./ActivityHeader";
import ActivitySummaryCards from "./ActivitySummaryCards";
import ActivityTrendChart from "./ActivityTrendChart";
import ActivityEventsChart from "./ActivityEventsChart";
import ActivityFilters from "./ActivityFilters";
import ActivityTable from "./ActivityTable";

const ActivityLogsPage = () => {
  return (
    <div className="min-h-screen space-y-6 bg-gray-50 p-6">
      <ActivityHeader />

      {/* Main box */}
      <div className="rounded-2xl border bg-white p-6 shadow-sm">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold">Activity Logs</h2>

          <div className="flex gap-3">
            <button className="rounded-lg border bg-white px-4 py-2 hover:bg-gray-50">
              Refresh
            </button>
            <button className="rounded-lg bg-teal-600 px-4 py-2 text-white hover:bg-teal-700">
              Export Logs
            </button>
          </div>
        </div>

        <ActivitySummaryCards />

        <div className="mt-6 grid gap-6 md:grid-cols-2">
          <ActivityTrendChart />
          <ActivityEventsChart />
        </div>

        <ActivityFilters />

        <ActivityTable />
      </div>
    </div>
  );
};

export default ActivityLogsPage;
